import React from 'react'
import Link from 'next/link'
import { attributes } from '../../content/global-header-nav.md'
import {
  ButtonFontSize,
  darkGreenButtonStyles,
  largePaddingStyles,
} from '../forms/elements/SubmitButton'

interface Props {
  title: string
  imageSrc: string
  list: [
    {
      title: string
    }
  ]
}

const About: React.FunctionComponent<Props> = ({ title, imageSrc, list }) => {
  const { applyLinkText, applyLinkUrl } = attributes

  return (
    <section className="xl:relative content-center gap-5 m-auto max-w-screen-2xl sm:px-8 md:px-12 md:py-[122px] md:grid md:grid-cols-2 xl:flex xl:gap-x-[200px] lg:px-24 lg:pt-[46px] lg:pb-[122px] xl:pb-[275px] ">
      <img
        className="hidden w-full md:block xl:max-w-[650px]"
        alt={title}
        src={imageSrc}
      />
      <div className="px-4 mt-[100px] xl:mt-[60px] mb-6 pb-14 sm:pb-12 md:p-0 md:m-auto lg:justify-self-end lg:self-center xl:w-3/4">
        <div className="text-center md:self-center md:text-left md:pl-8 lg:pl-24 xl:pl-0">
          <h1 className="mb-[40px] max-w-4xl py- xl:pt-[1.25rem] lg:mb-12 text-center text-3xl font-ttHovesBold text-green-100 text-bigTitleMobile leading-bigTitle md:text-5xl xl:text-[4.5rem] xl:leading-[5.375rem] xl:whitespace-nowrap">
            {title}
          </h1>
          <ul className="text-nptBase flex flex-col mx-auto list-disc list-inside gap-y-[35px] xl:gap-y-[56px] lg:m-auto font-ttHovesMedium text-green-100 md:pl-8 lg:text-xl xl:text-[1.25rem] xl:leading-[1.5rem] ">
            {list.map((item, i) => (
              <li
                key={`AboutListItem_${i}`}
                className="text-center md:text-left"
              >
                {item.title}
              </li>
            ))}
          </ul>
        </div>
      </div>
      <img className="w-full md:hidden" alt={title} src={imageSrc} />
      <div className="xl:absolute xl:bottom-[115px] xl:left-1/2 xl:-translate-x-1/2 px-12 pt-12 text-center mb-[122px] md:mb-0 md:col-span-2 lg:mt-20 lg:pb-3">
        <Link
          href={applyLinkUrl}
          className={`${darkGreenButtonStyles} ${largePaddingStyles} ${ButtonFontSize.small} mx-auto`}
          title="Join the Team"
          target="_blank"
          rel="noreferrer"
        >
          {applyLinkText}
        </Link>
      </div>
    </section>
  )
}

export default About
